import { Interceptor } from "@core/api/interceptors/interceptor";
import { notificationManager } from "@core/service-container";
import { AxiosResponse } from "axios";

export const notificationCountInterceptor: () => Interceptor<AxiosResponse> = () => ({
	onFulfilled: async response => {
		const unreadNotificationCount = parseInt(response.headers["x-unread-notification-count"]);
		const hasUnsentNotifications = response.headers["x-has-unsent-notifications"] === "true";
		if (unreadNotificationCount >= 0) {
			try {
				notificationManager.updateUnreadCount(unreadNotificationCount);
			} catch (e) {
				console.error("[notificationCountInterceptor] Failed to update new unread notification count", e);
			}
		}
		if (hasUnsentNotifications) {
			try {
				await notificationManager.fetchUnsentNotifications();
			} catch (e) {
				console.error("[notificationCountInterceptor] Failed to fetch unsent notifications", e);
			}
		}
		return response;
	},
	onRejected: error => Promise.reject(error),
});
